import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { guidesKeyes } from './guidesKeyes';

export interface EditableGuides {
  guideCategoryId: number;
  userId: number;
  customerId: number;
  name: string;
  order: number;
  private: boolean;
  createdAt: string;
  updatedAt: string;
}

const reorderGuides = async ({
  payload,
}: {
  payload: number[] | undefined;
}): Promise<EditableGuides[]> => {
  return (
    await EXPRESS_API.patch(`guides/reorder`, {
      payload,
    })
  ).data as EditableGuides[];
};
export const useReorderGuidesMutation = (
  setOrderUnactiveHandler: () => void
) => {
  const { showError } = useToastError();
  const queryClient = useQueryClient();
  return useMutation(reorderGuides, {
    onError: err => showError(err),
    onSuccess: async () => {
      await queryClient.refetchQueries(guidesKeyes.categorized());
      successToast({ title: 'You have successfully reordered guides!' });
      setOrderUnactiveHandler();
    },
  });
};
